import authSvcImpl, { AuthService } from "@/services/AuthService"
import propertySvcImpl, { PropertyService } from "@/services/PropertyService"
import tenantSvcImpl, { TenantService } from "@/services/TenantService"
import maintenanceSvcImpl, { MaintenanceService } from "@/services/MaintenanceService"
import fileSvcImpl, { FileService } from "@/services/FileService"
import spacesServiceImpl, { SpacesService } from "@/services/SpacesService"
import supportServiceImpl, { SupportService } from "@/services/SupportService"
import loyaltyServiceImpl, { LoyaltyService } from "@/services/LoyaltyService"
import orderServiceImpl, { OrderService } from "@/services/OrderService"
import amenityServiceImpl, { AmenityService } from "@/services/AmenityService"
import amenityBookingServiceImpl, { AmenityBookingService } from "@/services/AmenityBookingService"
import guestWaiverServiceImpl, { GuestWaiverService } from "@/services/GuestWaiverService"
import paymentServiceImpl, { PaymentService } from "@/services/PaymentService"
import guestInviteServiceImpl, { GuestInviteService } from "@/services/GuestInviteService"
import actionCodeServiceImpl, { ActionCodeService } from "@/services/ActionCodeService"
import walletServiceImpl, { WalletService } from "@/services/WalletService"

class Services {
    private static instance?: Services = undefined

    auth: AuthService
    files: FileService
    loyalty: LoyaltyService
    maintenance: MaintenanceService
    property: PropertyService
    tenant: TenantService
    spaces: SpacesService
    support: SupportService
    orders: OrderService
    amenities: AmenityService
    amenityBookings: AmenityBookingService
    guestWaiver: GuestWaiverService
    payments: PaymentService
    guestInvites: GuestInviteService
    actionCodes: ActionCodeService
    wallet: WalletService

    private constructor() {
        this.auth = authSvcImpl
        this.property = propertySvcImpl
        this.tenant = tenantSvcImpl
        this.maintenance = maintenanceSvcImpl
        this.files = fileSvcImpl
        this.spaces = spacesServiceImpl
        this.support = supportServiceImpl
        this.loyalty = loyaltyServiceImpl
        this.orders = orderServiceImpl
        this.amenities = amenityServiceImpl
        this.amenityBookings = amenityBookingServiceImpl
        this.guestWaiver = guestWaiverServiceImpl
        this.payments = paymentServiceImpl
        this.guestInvites = guestInviteServiceImpl
        this.actionCodes = actionCodeServiceImpl
        this.wallet = walletServiceImpl
    }

    static shared(): Services {
        if (Services.instance == undefined) {
            Services.instance = new Services()
        }
        return Services.instance
    }
}

export default Services.shared()
